import React from 'react';
import { 
	string,
	func, 
	array,
} from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style, {mobileStyle} from './style';
import { findoutTextType } from '../../../logics/questionBuilder';

const MobilePresenter = ({
	imageUrl,
	userName,
	favs,
	uid,
	onClickSearch,
	onClickCreate,
	className,
	t
}) => {
	return (
		<mobileStyle.Wrapper className={className}>
			<style.WelcomeUser>
				<div>
					{imageUrl ? (<style.UserIcon src={imageUrl} />) : <style.AnonymousUser />}
				</div>
				<h3>{t('home.Welcome',{userName})}</h3>
			</style.WelcomeUser>
			
			{favs && (
				<style.FavoriteList key={favs.length} favs={favs}/>
			)}
			{uid && (
				<style.ActivityHistory uid={uid}/>
			)}
			<mobileStyle.ActionButtons>
				<div>
					<style.ContainedButton onClick={onClickCreate}><style.PlusIcon/><span>{t('home.CreateQuiz')}</span></style.ContainedButton>
				</div>
				<div>
					<style.ContainedButton onClick={onClickSearch}><style.SearchIcon/><span>{t('home.SearchQuiz')}</span></style.ContainedButton>
				</div>
			</mobileStyle.ActionButtons>
		</mobileStyle.Wrapper>
	);
};
	

MobilePresenter.propTypes = {
	imageUrl : string,
	userName : string,
	favs : array.isRequired,
	uid : string,
	onClickSearch : func.isRequired,
	onClickCreate : func.isRequired,
	className : string,
	t : findoutTextType.isRequired
};

export default withNamespaces()(MobilePresenter);